export const ru = (__LOCALE_RU__ ? ({
  create_permission_tag: {
    title: 'Добавить',
    on_error: 'Не удалось создать тег доступа',
    on_groups_update_error: 'Тег создан, но не удалось привязать выбранные группы',
    on_success: 'Тег доступа создан',
    create_permission_tag_form: {
      title: 'Новый тег',
      groups: 'Группы',
      groups_empty: 'Нет доступных групп',
      groups_placeholder: 'Выберите',
      on_cancel: 'Отмена',
      on_submit: 'Создать',
      permission_tag: 'Название',
      validation: {
        duplicate: 'Тег доступа с таким названием уже существует',
        group_access_error: 'Недостаточно прав для редактирования группы {{groupName}}',
        max_length: 'Название тега должно быть не длиннее 36 символов',
        permissions_error: 'Недостаточно прав для редактирования групп',
        required: 'Введите название тега доступа',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  create_permission_tag: {
    title: 'Add',
    on_error: 'Failed to create permission tag',
    on_groups_update_error: 'Permission tag was created, but the selected groups could not be linked',
    on_success: 'Permission tag created',
    create_permission_tag_form: {
      title: 'New tag',
      groups: 'Groups',
      groups_empty: 'No groups available',
      groups_placeholder: 'Select',
      on_cancel: 'Cancel',
      on_submit: 'Create',
      permission_tag: 'Name',
      validation: {
        duplicate: 'A permission tag with this name already exists',
        group_access_error: 'Insufficient rights to edit group {{groupName}}',
        max_length: 'Permission tag name must be 36 characters or less',
        permissions_error: 'Insufficient rights to edit groups',
        required: 'Enter permission tag name',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  create_permission_tag: {
    title: 'Adicionar',
    on_error: 'Não foi possível criar a tag de acesso',
    on_groups_update_error: 'A tag de acesso foi criada, mas não foi possível vincular os grupos selecionados',
    on_success: 'Tag de acesso criada',
    create_permission_tag_form: {
      title: 'Nova tag',
      groups: 'Grupos',
      groups_empty: 'Nenhum grupo disponível',
      groups_placeholder: 'Selecionar',
      on_cancel: 'Cancelar',
      on_submit: 'Criar',
      permission_tag: 'Nome',
      validation: {
        duplicate: 'Já existe uma tag de acesso com esse nome',
        group_access_error: 'Não há permissões suficientes para editar o grupo {{groupName}}',
        max_length: 'O nome da tag deve ter no máximo 36 caracteres',
        permissions_error: 'Não há permissões suficientes para editar grupos',
        required: 'Informe o nome da tag de acesso',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  create_permission_tag: {
    title: 'Agregar',
    on_error: 'No se pudo crear la etiqueta de acceso',
    on_groups_update_error: 'La etiqueta de acceso se creó, pero no se pudieron vincular los grupos seleccionados',
    on_success: 'Etiqueta de acceso creada',
    create_permission_tag_form: {
      title: 'Nueva etiqueta',
      groups: 'Grupos',
      groups_empty: 'No hay grupos disponibles',
      groups_placeholder: 'Seleccionar',
      on_cancel: 'Cancelar',
      on_submit: 'Crear',
      permission_tag: 'Nombre',
      validation: {
        duplicate: 'Ya existe una etiqueta de acceso con este nombre',
        group_access_error: 'No tienes permisos suficientes para editar el grupo {{groupName}}',
        max_length: 'El nombre de la etiqueta debe tener 36 caracteres o menos',
        permissions_error: 'No tienes permisos suficientes para editar grupos',
        required: 'Introduce el nombre de la etiqueta de acceso',
      },
    },
  },
}) : {}) as Record<string, unknown>;
